import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

/**
 * Lädt die Google-Maps-JavaScript-API erst dann, wenn eine Karte tatsächlich angezeigt wird.
 * Vorher hing das Skript fest in index.html und wurde auf jeder Seite (Portal, Admin) geladen –
 * damit ging bei jedem Aufruf die IP-Adresse an Google, ohne dass eine Karte zu sehen war.
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
    private loading?: Promise<boolean>;

    load(): Promise<boolean> {
        if ((window as any).google?.maps) {
            return Promise.resolve(true);
        }
        if (!this.loading) {
            this.loading = new Promise<boolean>((resolve) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}`;
                script.async = true;
                script.defer = true;
                script.onload = () => resolve(true);
                script.onerror = () => {
                    this.loading = undefined;
                    resolve(false);
                };
                document.head.appendChild(script);
            });
        }
        return this.loading;
    }
}
